import React from 'react';
import { Reveal } from './Reveal';
const points = [{
  value: '+40',
  caption: 'Años de trayectoria'
}, {
  value: 'NYSE: PRI',
  caption: 'Compañía que cotiza públicamente'
}, {
  value: 'Licencias',
  caption: 'Según el área de servicios'
}, {
  value: 'Capacitación',
  caption: 'Durante el proceso'
}];
export function Credibility() {
  return <section className="w-full bg-ink py-24 sm:py-32 lg:py-40" aria-labelledby="credibility-title" data-id="element-38" data-mp="2ulp579b59x2v">
      <div className="mx-auto max-w-page px-5 sm:px-10 lg:px-12" data-id="element-39" data-mp="38g81r44eq6d9">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-24" data-id="element-40" data-mp="33esdl36xnjqn">
          <Reveal data-id="element-41" data-mp="3ib9pbvj1b0dq">
            <p className="font-sans text-[10px] font-medium uppercase tracking-widest2 text-champagne sm:text-[11px]" data-id="element-42" data-mp="3ibt79c8oporr">
              Respaldo
            </p>
            <h2 id="credibility-title" className="mt-8 font-sans text-[1.85rem] font-light uppercase leading-[1.12] text-ivory sm:text-[2.5rem]" data-id="element-43" data-mp="1nxry9yjf7ldy">
              Una oportunidad
              <br data-id="element-44" data-mp="31h8gach7h1r6" />
              con respaldo.
            </h2>
            <p className="mt-8 max-w-md font-sans text-[17px] font-light leading-relaxed text-steel-200 sm:text-lg" data-id="element-45" data-mp="35h942nq72paw">
              Conoce una oportunidad desarrollada dentro de una estructura
              establecida en la industria de servicios financieros.
            </p>
          </Reveal>

          <div className="grid grid-cols-1 gap-x-16 border-t border-champagne/30 sm:grid-cols-2" data-id="element-46" data-mp="3k6ou21hwiqpj">
            {points.map((point, i) => <Reveal key={point.value} delay={Math.min(i * 0.07, 0.25)} className="border-b border-champagne/20" data-id="element-47" data-mp="3p46sgxyalnja" data-mpi={i}>
                <div className="py-8 sm:py-10" data-id="element-48" data-mp="2124asawhc7e">
                  <p className="font-sans text-[1.75rem] font-light uppercase leading-none tracking-[0.01em] text-ivory sm:text-[2.25rem]" data-id="element-49" data-mp="1yplye18cztt">
                    {point.value}
                  </p>
                  <p className="mt-4 font-sans text-[13px] font-medium uppercase tracking-[0.16em] text-steel-200 sm:text-sm" data-id="element-50" data-mp="23u9fpqne79o0">
                    {point.caption}
                  </p>
                </div>
              </Reveal>)}
          </div>
        </div>

        <Reveal delay={0.1} data-id="element-51" data-mp="3g4k54vs9yoat">
          <p className="mt-16 max-w-2xl border-l border-champagne pl-6 font-serif text-xl italic leading-snug text-ivory/90 sm:mt-20 sm:pl-8 sm:text-2xl" data-id="element-52" data-mp="3g1o777gffzmd">
            Una oportunidad independiente dentro de una industria regulada, con
            productos y servicios reales para personas y familias.
          </p>
        </Reveal>
      </div>
    </section>;
}